import { useInmobiliariaImpersonation } from "@/contexts/InmobiliariaImpersonationContext";
import { VerComoPersonasSelector } from "@/components/admin/VerComoPersonasSelector";

/**
 * "Ver como" del Portal Inmobiliaria: por persona (regla de Eduardo, 2026-10-27). Solo quien entra
 * al portal (inmobiliarias, supervisores, etc.), en bloques por rol y con búsqueda en el servidor
 * (son ~850). Una inmobiliaria nunca lo ve; solo quien puede impersonar.
 */
export function InmobiliariaImpersonationSelector({ className }: { className?: string }) {
  const {
    impersonatedInmobiliariaEmail, impersonatedInmobiliariaName, setImpersonatedInmobiliaria, clearImpersonation,
  } = useInmobiliariaImpersonation();
  return (
    <VerComoPersonasSelector
      rutas={["/admin/portal-inmobiliaria/%"]}
      seleccionadoEmail={impersonatedInmobiliariaEmail}
      seleccionadoNombre={impersonatedInmobiliariaName}
      onElegir={(p) => setImpersonatedInmobiliaria(p.email, p.personaId, p.nombre, p.rolAccesoId, p.rolAccesoNombre)}
      onLimpiar={clearImpersonation}
      className={className}
    />
  );
}
